import { AwsRum, type AwsRumConfig } from "aws-rum-web";

declare global {
  interface Window {
    GLOBAL_CLOUDWATCH_APP_ID: string;
    GLOBAL_CLOUDWATCH_IDENTITY_POOL_ID: string;
    GLOBAL_CLOUDWATCH_REGION: string;
    GLOBAL_CLOUDWATCH_SAMPLE_RATE: string;
  }
}

export const initCloudWatchRum = (): void => {
  const defaultSampleRate = 0.1; // Default to 10% if not specified
  const appId = window.GLOBAL_CLOUDWATCH_APP_ID;
  const identityPoolId = window.GLOBAL_CLOUDWATCH_IDENTITY_POOL_ID;
  const region = window.GLOBAL_CLOUDWATCH_REGION;

  if (!appId || !identityPoolId || !region) {
    return;
  }

  const config: AwsRumConfig = {
    sessionSampleRate: window.GLOBAL_CLOUDWATCH_SAMPLE_RATE ? Math.min(1, Math.max(0, parseFloat(window.GLOBAL_CLOUDWATCH_SAMPLE_RATE))) : defaultSampleRate,
    identityPoolId,
    endpoint: `https://dataplane.rum.${region}.amazonaws.com`,
    telemetries: ["performance", "errors", "http"],
    allowCookies: true,
    enableXRay: false,
    signing: true,
  };

  try {
    // eslint-disable-next-line no-new
    new AwsRum(appId, import.meta.env.npm_package_version ?? "unknown", region, config); // SDK self-registers globally; return value not needed
  } catch {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
};
